import { TextFit } from "../../../../component-library";
import { TIFFormDataProps, useTIFFormData } from "../../../../hooks";

export function TIFDEDSignature({ tissueId }: Readonly<TIFFormDataProps>) {
    const { donorEligibilitySignature } = useTIFFormData({ tissueId });

    return (
        <>
            <TextFit style={{ width: "100%" }} maxFontSizePx={14}>
                <span className="fw-bold">Donor Eligibility Determined By:</span> {donorEligibilitySignature}
            </TextFit>
            <hr className="my-1" />
        </>
    );
}
